export default __webpack_public_path__ + "976b5194516ca86106ce818dc29837c4.png";